import { ApiService } from "../../api/api-service";
import { CreateJourneyPayload, JourneyItem } from "../Journey/journey.types";
// ── Sweetness Rating types (COMMENTED OUT) ──
// import { SweetnessRating, SweetnessCheckResponse, SweetnessRatingRecord } from "../Journey/journey.types";


/**
 * Create a new journey entry (or update if exists for that date)
 */
export const createBatchJourney = async (
  batchNo: string,
  payload: CreateJourneyPayload
): Promise<JourneyItem> => {
  try {
    const response = await ApiService.getInstance().post(
      `api/batch/${batchNo}/journey`,
      payload
    );
    return response.data.data;
  } catch (error) {
    console.error("Error creating journey:", error);
    throw error;
  }
};

/**
 *  NEW: Update an existing journey entry
 */
export const updateBatchJourney = async (
  batchNo: string,
  journeyId: string,
  payload: Partial<CreateJourneyPayload>
): Promise<void> => {
  try {
    await ApiService.getInstance().put(
      `api/batch/${batchNo}/journey/${journeyId}`,
      payload
    );
  } catch (error) {
    console.error("Error updating journey:", error);
    throw error;
  }
};

/**
 * Get all journey entries for a batch
 */
export const getBatchJourneys = async (
  batchNo: string
): Promise<JourneyItem[]> => {
  try {
    const response = await ApiService.getInstance().get(
      `api/batch/${batchNo}/journey`
    );
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching journeys:", error);
    throw error;
  }
};

/**
 * Delete a journey entry
 */
export const deleteBatchJourney = async (
  batchNo: string,
  journeyId: string
): Promise<void> => {
  try {
    await ApiService.getInstance().delete(
      `api/batch/${batchNo}/journey/${journeyId}`
    );
  } catch (error) {
    console.error("Error deleting journey:", error);
    throw error;
  }
};

// ── Sweetness / Student Rating API functions (COMMENTED OUT) ──

// export const checkSweetnessRatingRequired = async (
//   batchNo: string
// ): Promise<SweetnessCheckResponse> => {
//   try {
//     const response = await ApiService.getInstance().get(
//       `api/batch/${batchNo}/sweetness-check`
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error checking sweetness rating requirement:", error);
//     return { required: false };
//   }
// };

// export const checkSweetnessRatingRequired = async (
//   batchNo: string
// ): Promise<SweetnessCheckResponse> => {
//   try {
//     const response = await ApiService.getInstance().get(
//       `api/batch/${batchNo}/student-rating-check`
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error checking student rating requirement:", error);
//     return { required: false };
//   }
// };

// export const submitSweetnessRating = async (
//   batchNo: string,
//   journeyId: string,
//   ratings: SweetnessRating[]
// ): Promise<void> => {
//   await ApiService.getInstance().post(
//     `api/batch/${batchNo}/student-rating`,
//     { journey_id: journeyId, ratings }
//   );
// };

// export const fetchAllSweetnessRatings = async (): Promise<SweetnessRatingRecord[]> => {
//   try {
//     const response = await ApiService.getInstance().get("api/batch/student-ratings");
//     return response.data.data || [];
//   } catch (error) {
//     console.error("Error fetching all student ratings:", error);
//     throw error;
//   }
// };

// export const submitSweetnessRating = async (
//   batchNo: string,
//   journeyId: string,
//   ratings: SweetnessRating[]
// ): Promise<void> => {
//   await ApiService.getInstance().post(
//     `api/batch/${batchNo}/sweetness-rating`,
//     { journey_id: journeyId, ratings }
//   );
// };

/**
 * Fetch all submitted sweetness ratings across all batches (flat array)
 */
// export const fetchAllSweetnessRatings = async (): Promise<SweetnessRatingRecord[]> => {
//   try {
//     const response = await ApiService.getInstance().get("api/batch/sweetness-ratings");
//     return response.data.data || [];
//   } catch (error) {
//     console.error("Error fetching all sweetness ratings:", error);
//     throw error;
//   }
// };